<template>
  <v-row class="filters--list mb-4">
    <v-col cols="12" sm="12" md="3" lg="2" class="pb-0">
      <FilterBoolean
        :fetchData="fetchMissions"
        :label="$t('mission.filters.active')"
        :type="'activesOnly'"
      />
    </v-col>
    <v-col cols="12" sm="12" md="3" lg="2">
      <FilterDates :fetchData="fetchMissions" :label="getStartDateLabel()" :single-date-prop="'startDate'" :dateRange="true" :single-date="true"/>
    </v-col>
    <v-col cols="12" sm="12" md="3" lg="2">
      <FilterDates :fetchData="fetchMissions" :label="getEndDateLabel()" :single-date-prop="'endDate'" :dateRange="true" :single-date="true"/>
    </v-col>
    <v-col cols="12" sm="12" md="3" lg="2">
      <CitySelectFilter :fetch-data="fetchMissions" />
    </v-col>
  </v-row>
</template>

<script>
import FilterDates from '@/components/filters/FilterDates'
import FilterBoolean from '@/components/filters/FilterBoolean'
import CitySelectFilter from '@/components/city/CitySelectFilter'

import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'MissionListFilter',

  components: { 
    FilterDates,
    CitySelectFilter,
    FilterBoolean 
  },

  computed: {
    ...mapGetters(['isLoading']),
  },

  methods: {
    ...mapActions(['fetchMissions']),

    getStartDateLabel() {
      return this.$t(`mission.label.startDate`)
    },

    getEndDateLabel() {
      return this.$t(`mission.label.endDate`)
    },
  },
}
</script>